import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '../components/LandingPage.vue';
import MedeaMix from '../components/MedeaMix.vue';
import LinkGenerator from '../components/LinkGenerator.vue';
import TermsAndConditions from '../components/TermsAndConditions.vue';

const routes = [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage,
  },
  {
    path: '/terms',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
  },
  {
    path: '/mix',
    name: 'MedeaMix',
    component: MedeaMix,
  },
  {
    path: '/links',
    name: 'LinkGenerator',
    component: LinkGenerator,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  stringifyQuery: (query) => {
    // Custom query stringify to preserve %20 encoding for spaces instead of converting to +
    const params = [];

    for (const [key, value] of Object.entries(query)) {
      if (value !== null && value !== undefined) {
        // Use encodeURIComponent to ensure spaces are encoded as %20, not +
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(String(value));
        params.push(`${encodedKey}=${encodedValue}`);
      }
    }

    const queryString = params.join('&');
    return queryString || '';
  },
});

export default router;
